import React, { useEffect, useState } from "react";
import classes from './InvestAt.module.scss';
import $ from 'jquery';
import { useTranslation } from "react-i18next";

const buttons = [
    {
        id: 1,
        name: 'invest_at_tab_01_title',
    },
    {
        id: 2,
        name: 'invest_at_tab_02_title',
    },
    {
        id: 3,
        name: 'invest_at_tab_03_title',
    },
    {
        id: 4,
        name: 'invest_at_tab_04_title',
    },
    {
        id: 5,
        name: 'invest_at_tab_05_title',
    },
    {
        id: 6,
        name: 'invest_at_tab_06_title',
    },
];

const content = {
    1: [
        'invest_at_tab_01_text_01',
        'invest_at_tab_01_text_02',
    ],
    2: [
        'invest_at_tab_02_text_01',
    ],
    3: [
        'invest_at_tab_03_text_01',
        'invest_at_tab_03_text_02',
    ],
    4: [
        'invest_at_tab_04_text_01',
        'invest_at_tab_04_text_02',
        'invest_at_tab_04_text_03',
    ],
    5: [
        'invest_at_tab_05_text_01',
        'invest_at_tab_05_text_02',
        'invest_at_tab_05_text_03',
        'invest_at_tab_05_text_04',
    ],
    6: [
        'invest_at_tab_06_text_01',
        'invest_at_tab_06_text_02',
    ],
};

const InvestAt = () => {
    const { t } = useTranslation();
    const [ currentTab, setCurrentTab ] = useState(1);
    var initSize = function() {
        var start_element = $('.tabs-block li:first-of-type');
        var $label = $('.investAtTabs_label');
        var initWidth = start_element.css('width')	
        $label.css('width', initWidth);
    }
    useEffect(() => {
        initSize();
        $('.tabs-block li').on('click', function(){
            var $label = $('.investAtTabs_label');	
            var $this = $(this);
            var el_width = $this.width();
            var offset = $this.offset();
            $label
                .offset({ left: offset.left })
                .offset({ top: offset.top })
                .css('width', el_width)
        });
    }, []);
    return (
        <section className="container">
            <div className={classes.investAt}>
                <h2 className={[classes.title, 'font-40'].join(' ')}>
                    {t('invest_at_title')}
                </h2>
                <h3 className={[classes.subtitle, 'font-30'].join(' ')}>
                    {t('invest_at_subtitle')}
                </h3>
                <div className={classes.tabs}>
                    <ul className={`${classes.buttons} tabs-block`}>
                        <div className={`${classes.label} investAtTabs_label`}></div>
                        {buttons.map((btn) =>
                            <li
                                key={btn.id}
                                onClick={() => setCurrentTab(btn.id)}
                                className={`${classes.btn} ${currentTab === btn.id && classes.btnActive}`}
                            >
                                <span>
                                    {t(btn.name)}
                                </span>
                            </li>
                        )}
                    </ul>
                    <div className={classes.content}>
                        {content[currentTab].map((par, index) =>
                            <p key={index}>{t(par)}</p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InvestAt;
